export enum Roles {
  admin="admin",
  moderator="moderator",
  owner="owner",
}

export interface IEditNichesDialogProps {
  gifId: string;
  role: Roles;
}
